<template lang="pug">
validation-observer(ref="observer", tag="div")
  app-divider(label="Dados do Imóvel").mb-30px
  el-row.labelDiv(:gutter="30")
    el-col.inputDiv(:span="8")
      validation-provider(rules="required", v-slot="{ errors }", :name="nomeAba + '/Denominação Imóvel'")
        app-label(label="Denominação do Imóvel: ", :required="true")
        el-input.input(
          name="denominacao"
          v-model="imovel.denominacao",
          :class="{'erro' : errors.length}"
        )
        span.help.erro {{ errors[0] }}
    el-col.inputDiv(:span="8")
      app-label(label="Matrícula: ", :required="false")
      el-input.input(
        name="numeroMatricula"
        v-model="imovel.numeroMatricula",
      )
    el-col.inputDiv(:span="8")
      app-label(label="Averbação Transferência de domínio: ", :required="false")
      el-input.input(
        name="averbacaoTransferenciaDominio"
        v-model="imovel.averbacaoTransferenciaDominio",
      )
  el-row.labelDiv.mt-10px(:gutter="30")
    el-col.inputDiv(:span="8")
      app-label(label="Averbação Georreferenciamento: ", :required="false")
      el-input.input(
        name="averbacaoGeorreferenciamento"
        v-model="imovel.averbacaoGeorreferenciamento",
      )
    el-col.inputDiv(:span="8")
      app-label(label="CNS: ", :required="false")
      el-input.input(
        name="cns"
        v-model="imovel.cnsMatricula",
      )
    el-col.inputDiv(:span="8")
      app-label(label="SNCR: ", :required="false")
      el-input.input(
        name="sncr"
        v-model="imovel.sncr",
      )
  el-row.labelDiv.mt-10px(:gutter="30")
    el-col.inputDiv(:span="8")
      app-label(label="NIRF: ", :required="false")
      el-input.input(
        name="nirf"
        v-model="imovel.nirf",
      )
    el-col.inputDiv(:span="8")
      app-label(label="Cadastro CAR: ", :required="false")
      el-input.input(
        name="numeroReciboCar"
        v-model="imovel.numeroReciboCar",
        v-mask="carMask"
      )
  app-divider(label="Localização do Imóvel").mb-30px
  validation-provider(v-slot="{ errors }", name="Georreferenciamento/Geometria")
    mapa-analise-geomensor(
      v-model="geometrias",
      :localizacoes="geometrias",
      :tipoCadastro="'RF'",
      name="Geometria",
      idMapa="mapaAnaliseGeomensor",
      :errors="errors"
      :addOrtoFotos="true"
      @shapefileUploaded="setShapefile"
      @shapefileRemoved="removeShapefile"
    )
  app-documentos(
    :maxSize='25',
    :valid-extensions="['doc', 'docx', 'jpeg', 'jpg', 'pdf', 'png']",
    :documentos="imovel.documentos"
    :tiposDocumentos="documentos"
    :tiposDocumentosObrigatorios="documentosObrigatorio"
    :observer="this.$refs.observer",
    aba="Imovel"
    titulo="Documentos do Imóvel"
  )
</template>

<script>
import { mapActions } from 'vuex'
import AppLabel from '@/components/AppLabel.vue'
import AppDocumentos from '@/screens/central/components/cadastro/AppDocumentos'
import AppDivider from '@/components/AppDivider.vue'
import MapaAnaliseGeomensor from '@/screens/analise/components/MapaAnaliseGeomensor'

export default {
  components: {
    AppDocumentos,
    AppLabel,
    AppDivider,
    MapaAnaliseGeomensor
  },

  props: {
    jsonCadastro: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      nomeAba: 'Imóvel',
      documentos: [],
      geometrias: [],
      documentosObrigatorio: [],
      carMask: {
        mask: 'AA-NNNNNNN-FFFF.FFFF.FFFF.FFFF.FFFF.FFFF.FFFF.FFFF',
        tokens: {
          A: {
            pattern: /[a-zA-Z]/,
            transform: v => v.toLocaleUpperCase()
          },
          N: {
            pattern: /\d/
          },
          F: {
            pattern: /[0-9a-fA-F]/,
            transform: v => v.toLocaleUpperCase()
          }
        }
      }
    }
  },

  watch: {
    geometrias (newVal) {
      if (!this.jsonCadastro?.georreferenciamento?.localizacoes) {
        this.jsonCadastro.georreferenciamento = {
          localizacoes: newVal
        }
      } else {
        this.jsonCadastro.georreferenciamento.localizacoes = newVal
      }
    }
  },

  async created () {
    this.documentos = await this.findDocumentos('imovelCadastroRf')
    if (this.jsonCadastro?.georreferenciamento?.localizacoes.length) {
      this.geometrias = this.jsonCadastro.georreferenciamento.localizacoes
    }
  },

  methods: {
    ...mapActions({
      findDocumentos: 'tipoDocumento/findTiposDocumento'
    }),

    setShapefile ({fileName, fileKey}) {
      this.jsonCadastro.georreferenciamento.localizacoes.push({
        fileName,
        fileKey,
        tipoDocumento: {
          codigo: 'MAPAS'
        }
      })
    },

    removeShapefile () {
      this.jsonCadastro.georreferenciamento.localizacoes = this.jsonCadastro.georreferenciamento.localizacoes.filter(d => d.tipoDocumento.codigo !== 'MAPAS')
    },

    async validate () {
      return this.$refs.observer.validate()
    }
  },

  computed: {
    imovel () {
      return this.jsonCadastro.imovel
    }
  }

}
</script>

<style lang="scss" scoped>
@media (max-width: 780px) {
  .labelDiv {
    display: flex;
    flex-direction: column;
  }
  .inputDiv {
    width: 100%;
  }
}
.mt-10px {
  margin-top: 10px;
}

.input {
  width: 100%;
}

.mb-30px {
  margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/components/cadastroRf/AppFormularioImovel.vue